import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import T from '../../../app/Locale';
import Modal from '../../Components/ComponentModal';
import { getCookie, setCookie } from '../../Utils/Cookie';
const ScoreModal = () => {
    const [, rerender] = useState(false);
    const onHide = () => {
        setCookie('hide-test-modal', '1', 1);
        rerender(true);
    };
    if (getCookie('hide-test-modal')) {
        return null;
    }
    return (_jsx(Modal, Object.assign({ id: 'modal-test', fastRender: true, isWide: true }, { children: _jsxs("div", { children: [_jsx("h2", { children: T.translate('selectPartnerModal.takeTest.title') }), _jsx("p", { dangerouslySetInnerHTML: { __html: T.translate('selectPartnerModal.takeTest.content') } }), _jsx("br", {}), _jsx("a", Object.assign({ className: 'tailwind-reset btn bg-dark-teal text-white hover:text-white text-lg w-full py-3 cursor-pointer md:w-auto md:px-12', href: '/onboarding' }, { children: T.translate('selectPartnerModal.takeTest.cta') })), _jsx("span", Object.assign({ className: 'ml-4 hover:underline', onClick: onHide, id: 'takeTestCancel' }, { children: T.translate('selectPartnerModal.takeTest.cancel') }))] }) })));
};
export default ScoreModal;
